import {makeAutoObservable} from "mobx";
import {ViewController} from "data/types/structure";
import {injectable, inject} from "inversify";
import React from "react";
import {Bindings} from "data/constants/bindings";
import type {IUserStore} from "data/stores/user/user.store";
import {AxiosError} from "axios";
import type {IModalsStore} from "data/stores/modals/modals.store";
import {ModalType} from "data/enums";

export interface IBackdoorController extends ViewController {
	onSubmit: (e: React.FocusEvent<HTMLFormElement>) => void;
}

@injectable()
export class BackdoorController implements IBackdoorController {
	constructor(
		@inject(Bindings.UserStore) private _userStore: IUserStore,
		@inject(Bindings.ModalsStore) private _modalStore: IModalsStore
	) {
		makeAutoObservable(this);
	}

	onSubmit = (e: React.FocusEvent<HTMLFormElement>) => {
		e.preventDefault();
		const formData = new FormData(e.target);

		this._userStore.backdoor(formData).catch((e) => {
			const err = e as AxiosError;
			this._modalStore.showModal(ModalType.ERROR, {
				message: err.message,
			});
		});
	};
}
